import React from 'react';
import { useViewChangeTracker } from '../../../hooks/useViewChangeTracker';
import { GenesGtpHeatmap } from './GenesGtpHeatmap';
import { GenesGtpSingleProfile } from './GenesGtpSingleProfile';
import AcademicPlanFeatureGate from '@/components/Modal/AcademicPlanFeatureGate';
import { useAuth } from '@/store/hooks/useAuth';
import { isAcademicPlanFeatureRestricted } from '@/utils/premiumPlanFeatures';

type GenesGraphsProps = {
  source: string;
  view: string;
  names: Array<{ id: string; name?: string; label?: string }>;
};

function GenesGraphs({ source, view, names }: GenesGraphsProps) {
  useViewChangeTracker('GenesGraphs', view, 'graph');
  const { isAcademic, isAuthenticated } = useAuth();
  const isRestricted = isAcademicPlanFeatureRestricted(isAcademic, isAuthenticated);

  const content =
    names.length < 2 ? (
      <GenesGtpSingleProfile source={source} view={view} names={names} />
    ) : (
      <GenesGtpHeatmap source={source} view={view} names={names} />
    );

  return (
    <AcademicPlanFeatureGate featureName="GTAP" isRestricted={isRestricted}>
      {content}
    </AcademicPlanFeatureGate>
  );
}

export default React.memo(GenesGraphs);
